import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Global } from '../../global';
import { ApiService } from '../../service/apiServices';
import { AuthService } from '../../service/auth/auth.service';

@Component({
  selector: 'app-acolhimento-caps',
  templateUrl: './acolhimento-caps.component.html',
  styleUrls: ['./acolhimento-caps.component.css']
})
export class AcolhimentoCapsComponent implements OnInit {

  filtro: any = '';
  resultCidadao: any = [];
  pagina: any = 1;
  totalPorPagina: any = 300;
  totalPagina: any = 1;

  cidadaoSelecionado: any = null;
  presenca: any = JSON.parse(localStorage.getItem('@DigtVentry:presencaUser'));
  dados: any = JSON.parse(localStorage.getItem('dadosPresencaUser'));

  // listas das APIs CAPS
  listaProfissionais: any = [];
  listaOrigemEncaminhamento: any = [];
  listaSituacaoMoradia: any = [];
  listaBeneficioSocial: any = [];
  listaRiscoAutolesao: any = [];
  listaRegimeAtendimento: any = [];

  // modelo do acolhimento (seções 2, 3 e 4)
  acolhimento: any = this.novoAcolhimento();

  constructor(
    public service: ApiService,
    private global: Global,
    private location: Location,
    private router: Router,
    private authService: AuthService
  ) {
    this.authService.currentPresenca.subscribe(res => {
      if (res) {
        this.presenca = res;
      }
    });

    // só acessa a tela com presença marcada (igual às demais telas)
    if (!this.dados) {
      this.authService.logoutUser();
    }
  }

  // extrai só os dígitos da data mascarada (ngx-mask remove os separadores no model)
  dataDigitos = (dataMask) => ('' + (dataMask || '')).replace(/\D/g, '');

  // "ddmmaaaa" -> Date (ou null se inválida)
  parseData = (dataMask) => {
    const v = this.dataDigitos(dataMask);
    if (v.length !== 8) return null;
    const d = new Date(+v.substring(4, 8), +v.substring(2, 4) - 1, +v.substring(0, 2));
    return isNaN(d.getTime()) ? null : d;
  }

  ngOnInit() {
    this.carregarListasCaps();
  }

  novoAcolhimento() {
    return {
      // 2. Escuta inicial
      origem_encaminhamento_id: undefined,
      profissional_acolhedor_id: undefined,
      motivo_busca: '',
      historia_saude_mental: '',
      situacao_moradia_id: undefined,
      beneficio_social_id: undefined,
      // 3. Avaliação de risco
      risco_autolesao_id: undefined,
      risco_heteroagressao: false,
      uso_substancias_crise: false,
      observacoes_risco: '',
      // 4. Decisão
      regime_atendimento_id: undefined,
      tecnico_referencia_id: undefined,
      cid10_id: undefined,
      cid10: '',
      data_proximo_atendimento: '',
      plano_inicial: ''
    };
  }

  carregarListasCaps() {
    this.carregarLista('CapsOrigemEncaminhamento', 'listaOrigemEncaminhamento');
    this.carregarLista('CapsSituacaoMoradia', 'listaSituacaoMoradia');
    this.carregarLista('CapsBeneficioSocial', 'listaBeneficioSocial');
    this.carregarLista('CapsRiscoAutolesao', 'listaRiscoAutolesao');
    this.carregarLista('CapsRegimeAtendimento', 'listaRegimeAtendimento');
  }

  carregarLista = (endpoint, alvo) => {
    this.service.Get(endpoint).then(res => {
      this[alvo] = Array.isArray(res) ? res : (res['conteudo'] || []);
    }).catch(res => {
      if (res.status == 401 || res.error.status == 401) {
        Swal.close();
        this.authService.logoutUser();
      }
    });
  }

  obterListaCidadaos = () => {
    if (this.filtro.length == 0) {
      Swal.fire('Erro', 'Favor digitar um filtro.', 'error');
      return;
    }

    var busca = this.filtro;
    if (!isNaN(parseInt(this.filtro[0])))
      busca = this.global.removeMask(this.filtro);

    Swal.fire({
      title: 'Favor aguarde',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    Swal.showLoading();
    this.service.Get(`Cidadao?Skip=${this.pagina}&Take=${this.totalPorPagina}&Busca=${busca}`).then(res => {
      this.resultCidadao = res['conteudo'];
      if (this.resultCidadao.length > 0) {
        this.totalPagina = Math.ceil(res['quantidade_total'] / this.totalPorPagina);
      }
      for (let cidadao of this.resultCidadao) {
        this.global.applyMask(cidadao);
      }
      Swal.close();
      if (this.resultCidadao.length == 0) {
        Swal.fire('Atenção', 'Esse paciente não foi encontrado em nosso sistema.', 'warning');
      }
    }).catch(res => {
      if (res.status == 401 || res.error.status == 401) {
        Swal.close();
        this.authService.logoutUser();
      }
      Swal.close();
      Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
    });
  }

  selecionarCidadao = (item) => {
    Swal.fire({
      title: 'Favor aguarde',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    Swal.showLoading();
    this.service.Get(`Cidadao/${item.id}`).then(res => {
      this.cidadaoSelecionado = this.prepararCidadao(res);
      this.acolhimento = this.novoAcolhimento();
      Swal.close();
    }).catch(res => {
      // fallback: usa o próprio item da busca caso o detalhe falhe
      if (res.status == 401 || res.error.status == 401) {
        Swal.close();
        this.authService.logoutUser();
        return;
      }
      this.cidadaoSelecionado = this.prepararCidadao(item);
      this.acolhimento = this.novoAcolhimento();
      Swal.close();
    });
  }

  prepararCidadao = (cidadao) => {
    // aplica máscaras de cpf/cns/telefone para exibição
    if (cidadao) {
      this.global.applyMask(cidadao);
    }
    return cidadao;
  }

  limparSelecao = () => {
    this.cidadaoSelecionado = null;
    this.acolhimento = this.novoAcolhimento();
  }

  // ---- Profissional acolhedor (autocomplete) ----
  selecionarProfissionalAcolhedor = (item) => {
    this.acolhimento.profissional_acolhedor_id = item ? item.id : undefined;
  }

  // ---- Técnico de referência (autocomplete) ----
  selecionarTecnicoReferencia = (item) => {
    this.acolhimento.tecnico_referencia_id = item ? item.id : undefined;
  }

  // ---- CID-10 (autocomplete) ----
  selecionarCid = (item) => {
    this.acolhimento.cid10_id = item ? item.id : undefined;
    this.acolhimento.cid10 = item ? item.nome : '';
  }

  // ---- Risco de autolesão (cards) ----
  selecionarRisco = (id) => {
    this.acolhimento.risco_autolesao_id = id;
  }

  corRisco = (item) => {
    // remove acentos para casar "médio" -> "medio", etc.
    const t = (('' + (item.codigo || '')) + ' ' + ('' + (item.nome || '')))
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    if (t.indexOf('alto') >= 0) return 'risco-alto';
    if (t.indexOf('med') >= 0) return 'risco-medio';
    if (t.indexOf('baix') >= 0 || t.indexOf('ausen') >= 0) return 'risco-baixo';
    return '';
  }

  // ---- Decisão ----
  cancelar = () => {
    this.limparSelecao();
  }

  finalizar = () => {
    if (!this.cidadaoSelecionado) {
      Swal.fire('Atenção', 'Selecione um paciente.', 'warning');
      return;
    }
    if (!this.acolhimento.origem_encaminhamento_id || !this.acolhimento.profissional_acolhedor_id
      || !this.acolhimento.motivo_busca || !this.acolhimento.risco_autolesao_id
      || !this.acolhimento.regime_atendimento_id || !this.acolhimento.tecnico_referencia_id) {
      Swal.fire('Atenção', 'Preencha os campos obrigatórios (*) das seções de escuta, risco e decisão.', 'warning');
      return;
    }

    // Data do próximo atendimento: se informada, só aceita data futura
    if (this.acolhimento.data_proximo_atendimento) {
      const dataProximo = this.parseData(this.acolhimento.data_proximo_atendimento);
      if (!dataProximo) {
        Swal.fire('Atenção', 'Data do próximo atendimento inválida.', 'warning');
        return;
      }
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      if (dataProximo <= hoje) {
        Swal.fire('Atenção', 'A data do próximo atendimento deve ser uma data futura.', 'warning');
        return;
      }
    }

    const payload = {
      cidadao_id: this.cidadaoSelecionado.id,
      clinica_medica_id: this.presenca ? (this.presenca.clinica_medica_id || this.presenca.clinica_id) : null,
      escuta_origem_encaminhamento_id: this.acolhimento.origem_encaminhamento_id,
      escuta_profissional_acolhedor_id: this.acolhimento.profissional_acolhedor_id,
      escuta_queixa_principal: this.acolhimento.motivo_busca,
      escuta_historico_saude_mental: this.acolhimento.historia_saude_mental,
      escuta_situacao_moradia_id: this.acolhimento.situacao_moradia_id || null,
      escuta_beneficio_social_id: this.acolhimento.beneficio_social_id || null,
      avaliacao_risco_autolesao_id: this.acolhimento.risco_autolesao_id,
      avaliacao_risco_heteroagressao: this.acolhimento.risco_heteroagressao,
      avaliacao_uso_substancias_em_crise: this.acolhimento.uso_substancias_crise,
      avaliacao_observacao: this.acolhimento.observacoes_risco,
      decisao_regime_atendimento_id: this.acolhimento.regime_atendimento_id,
      decisao_profissional_referencia_id: this.acolhimento.tecnico_referencia_id,
      decisao_cid_id: this.acolhimento.cid10_id || null,
      decisao_data_proximo_atendimento: this.dataParaIso(this.acolhimento.data_proximo_atendimento),
      decisao_plano_inicial: this.acolhimento.plano_inicial
    };

    Swal.fire({ title: 'Salvando acolhimento', allowOutsideClick: false, allowEscapeKey: false });
    Swal.showLoading();
    this.service.Post(`CapsAcolhimento`, payload).then(res => {
      Swal.close();
      const atendimentoId = res && res['atendimento_id'];
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: 'Acolhimento finalizado com sucesso!',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(result => {
        if (result.isConfirmed) {
          this.limparSelecao();
          // segue o mesmo fluxo da tela de atendimentos: inicia o prontuário e navega
          if (atendimentoId) {
            this.iniciarProntuario(atendimentoId);
          }
        }
      });
    }).catch(res => {
      if (res.status == 401 || res.error.status == 401) {
        Swal.close();
        this.authService.logoutUser();
        return;
      }
      Swal.close();
      const erro = res.error || {};
      // backend retorna ora { codigo, messagem }, ora { erros: [{ messagem }] }
      const mensagem = erro.messagem
        || (erro.erros && erro.erros[0] && erro.erros[0].messagem)
        || 'Erro ao salvar o acolhimento';
      Swal.fire('Erro', `${mensagem}`, 'error');
    });
  }

  // Inicia o prontuário do atendimento gerado pelo acolhimento, seguindo o mesmo
  // fluxo da tela de atendimentos (POST Atendimento/{id}/Prontuario) antes de navegar.
  iniciarProntuario = (atendimentoId) => {
    if (!this.presenca || !this.presenca.id) {
      // sem presença marcada não dá pra iniciar o prontuário (ex.: usuário admin)
      Swal.fire('Atenção', 'Acolhimento salvo, mas não foi possível abrir o prontuário: nenhuma presença marcada.', 'warning');
      return;
    }

    Swal.fire({ title: 'Iniciando atendimento', allowOutsideClick: false, allowEscapeKey: false });
    Swal.showLoading();
    this.service.Post(`Atendimento/${atendimentoId}/Prontuario`, { presenca_id: this.presenca.id }).then(res => {
      Swal.close();
      this.router.navigate([`prontuario/${atendimentoId}`]);
    }).catch(res => {
      if (res.status == 401 || res.error.status == 401) {
        Swal.close();
        this.authService.logoutUser();
        return;
      }
      Swal.close();
      const erro = res.error || {};
      const mensagem = erro.messagem
        || (erro.erros && erro.erros[0] && erro.erros[0].messagem)
        || 'Erro ao abrir o prontuário';
      Swal.fire('Erro', `${mensagem}`, 'error');
    });
  }

  // converte a data mascarada para ISO datetime; null se vazia/incompleta
  dataParaIso = (dataMask) => {
    const d = this.parseData(dataMask);
    if (!d) return null;
    const yyyy = d.getFullYear();
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return `${yyyy}-${mm}-${dd}T00:00:00`;
  }

}
